import {Package} from './Package';
import {Fabric} from './Fabric';

export class FabricCollection {
  static ACTIVE = 'active';
  static INACTIVE = 'inactive';
  public id: number;
  public name: string;
  public dealerPrice: number;
  public customerPrice: number;
  public status: boolean;
  public discounted: boolean;
  public position: string;
  public attachedFabrics: number;
  public translations: any;
  public fabrics: Fabric[];
  public isCustom?: boolean;
  public fabricName?: string;
  public fabricColorName?: string;
  constructor() {
    this.translations = [];
  }
}
